import React from 'react'
import Weather from './Weather'

function Home() {
  return (
    <div>
        <Weather/>
    </div>
  )
}

export default Home